import { useFormContext } from "react-hook-form";

import Grid from "@mui/material/Grid";

import {
  PriorClaimSource,
  PriorClaimsQuestion,
  QuestionType,
} from "@covertree/new-business-graphql";
import {
  PriorClaimsForm,
  PriorClaimsFormInput,
} from "@covertree/new-business-forms";

import { PriorClaimQuestionContent } from "./PriorClaimQuestionContent";

function isQuestionVisible(
  values: PriorClaimsFormInput,
  conditions?: string[] | null
): boolean {
  if (!conditions) return true;
  return conditions.some((condition) => {
    let [field, value] = condition.split("=");
    field = field.trim();
    value = value.trim().slice(1, -1);
    return values[field as keyof PriorClaimsFormInput] === value;
  });
}

interface PriorClaimQuestionProps {
  question: PriorClaimsQuestion;
  claimIndex: number;
  claim: Partial<PriorClaimsFormInput>;
  disabled?: boolean;
}

export function PriorClaimQuestion({
  question,
  claimIndex,
  claim,
  disabled,
}: PriorClaimQuestionProps) {
  const { getValues, setValue } = useFormContext<PriorClaimsForm>();
  const currentValues = getValues().claims[claimIndex];

  if (!isQuestionVisible(currentValues, question.visibleOnPickedOptions)) {
    setValue(
      `claims.${claimIndex}.${question.fieldName}`,
      question.type === QuestionType.Checkbox ? false : undefined,
      {
        shouldDirty: false,
      }
    );
    return;
  }

  return (
    <Grid
      item
      lg={question.type === QuestionType.Checkbox ? 12 : 6}
      xs={12}
      key={`priorClaimQuestion${question.fieldName}`}>
      <PriorClaimQuestionContent
        question={question}
        claimIndex={claimIndex}
        disabled={claim.source !== PriorClaimSource.UserDeclared || disabled}
      />
    </Grid>
  );
}
